module.exports = __webpack_public_path__ + "static/img/1025_small.e5135bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1025_small.png
// module id = YYSQ
// module chunks = 1